import loadingReducer from '../connected-components/loader/reducer';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: loadingReducer,
};
